import React from 'react';
import { useGetInboxNotificationsQuery } from '../../../services/api/inboxApi';
import { getUnreadInboxNotificationCount } from '../../../utils/NotificationsUtils';

import { NotificationBadge } from '../../UI/Badges';

export const InboxNotificationBadge = () => {
  const { data: inboxNotifications } = useGetInboxNotificationsQuery();

  const unreadNotificationCount = React.useMemo(
    () => getUnreadInboxNotificationCount(inboxNotifications),
    [inboxNotifications],
  );

  return (
    <NotificationBadge
      showZero={false}
      isSidebar
      content={unreadNotificationCount}
    />
  );
};
